function StreamStopIcon({ width = 23, height = 23 }) {
    return (
        <svg
            width={`${width}`}
            height={`${height}`}
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.5 2.875C6.73684 2.875 2.875 6.73684 2.875 11.5C2.875 16.2632 6.73684 20.125 11.5 20.125C16.2632 20.125 20.125 16.2632 20.125 11.5C20.125 6.73684 16.2632 2.875 11.5 2.875ZM1.4375 11.5C1.4375 5.94263 5.94263 1.4375 11.5 1.4375C17.0574 1.4375 21.5625 5.94263 21.5625 11.5C21.5625 17.0574 17.0574 21.5625 11.5 21.5625C5.94263 21.5625 1.4375 17.0574 1.4375 11.5ZM7.1875 8.625C7.1875 8.24375 7.33895 7.87812 7.60853 7.60853C7.87812 7.33895 8.24375 7.1875 8.625 7.1875H14.375C14.7562 7.1875 15.1219 7.33895 15.3915 7.60853C15.661 7.87812 15.8125 8.24375 15.8125 8.625V14.375C15.8125 14.7562 15.661 15.1219 15.3915 15.3915C15.1219 15.661 14.7562 15.8125 14.375 15.8125H8.625C8.24375 15.8125 7.87812 15.661 7.60853 15.3915C7.33895 15.1219 7.1875 14.7562 7.1875 14.375V8.625Z"
                fill="#666"
            />
        </svg>
    );
}

export default StreamStopIcon;
